import { RootActions } from 'types/state';
import FeatureFlags from '../../../ff.json';
import * as ActionsTypes from './actionTypes';

export type FFState = FeatureFlag[]

export interface FeatureFlag {
  id: string
  name: string
  isActive: boolean
}

export const initialState = FeatureFlags.features;

const reducer = (state: FFState = initialState, action: RootActions) => {
  switch (action.type) {
    case ActionsTypes.SET_FEATURE_FLAG_STATE:
      // TODO: Test immutability
      return state.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            isActive: action.payload.state,
          };
        }

        return item;
      });

    default:
      return state;
  }
};

export default reducer;
